// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3Xed6","title":"Images45_title__eZlmQ","images":"Images45_images__3942w"};